import { useEffect, useRef, useState } from 'react';
import { useIntl } from 'react-intl';

import { ICore } from 'adyen-web-new';

import { nonAwaitedPromiseHandler } from '@utils/async';

import { IInitializeAdyenApi } from '../model';
import { initializeAdyen } from '../utils';

export const useAdyenLib = ({
  messages,
  configuration,
  onSubmit,
  onChange,
  onAdditionalDetail,
  availablePaymentMethods,
}: IInitializeAdyenApi) => {
  const { formatMessage } = useIntl();

  const [adyenLib, setAdyenLib] = useState<ICore | null>(null);

  const componentInitialized = useRef<boolean>(false);

  /**
   * This useEffect initializes adyen client library
   * It handles that the library is being called only once and stores api element into reference
   */
  useEffect(() => {
    const handleAdyenLibraryLoad = async () => {
      if (componentInitialized.current || !availablePaymentMethods || !configuration.clientKey) {
        return;
      }

      const lib = await initializeAdyen({
        onChange,
        onSubmit,
        onAdditionalDetail,
        availablePaymentMethods,
        configuration,
        messages,
      });

      /**
       * This reference is really important and should NEVER be removed
       * It handles that the library load is performed only once
       * Since adyen library is loaded asynchronously and react support concurrent rendering
       * without this reference we would end up in infinite render cycle loop.
       */
      componentInitialized.current = true;

      setAdyenLib(lib);
    };

    nonAwaitedPromiseHandler(handleAdyenLibraryLoad);
  }, [availablePaymentMethods, configuration, formatMessage, messages, onAdditionalDetail, onChange, onSubmit]);

  return adyenLib;
};
